import classnames from 'classnames'
import { SearchResultsList } from './SearchResultsList'
import { SearchResultsEmpty } from './SearchResultsEmpty'
import { useListingSearchContext } from '../../../../../context/listingSearch'
import { BotHeadSpinWithMessage } from '../../../../shared/Loading/BotHeadSpinWithMessage'

import styles from './SearchModalResults.module.scss'

export const SearchModalResults = () => {
  const { loading, isInEmptyState, isInNoResultsState } =
    useListingSearchContext()

  const isEmpty = isInEmptyState || isInNoResultsState

  return (
    <div className={classnames(styles.results, isEmpty && styles.center)}>
      {loading && <BotHeadSpinWithMessage className={styles.loader} />}
      {!loading && isEmpty && <SearchResultsEmpty />}
      {!loading && !isEmpty && <SearchResultsList />}
    </div>
  )
}
